import { render, staticRenderFns } from "./PointsGoodsPreview.vue?vue&type=template&id=d3270934&scoped=true&"
import script from "./PointsGoodsPreview.vue?vue&type=script&lang=js&"
export * from "./PointsGoodsPreview.vue?vue&type=script&lang=js&"
import style0 from "./PointsGoodsPreview.vue?vue&type=style&index=0&id=d3270934&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3270934",
  null
  
)

export default component.exports